
$(document).ready(function(e){
	if ($('.field.address-autocomplete-field').length > 0){
		$('.field.address-autocomplete-field').each(function(){
			var dom = $(this);
			var input = dom.find('input');

			var components_to_capture = {
				street_number: 'short_name',
				route: 'long_name',
				//locality: 'long_name',
				sublocality_level_1: 'long_name',
				//administrative_area_level_1: 'short_name',
				postal_code: 'long_name'
			};

			// Set Wellington Region bounds
			var wellingtonRegionBounds = new google.maps.LatLngBounds(
				new google.maps.LatLng(-41.712409, 174.519990),
				new google.maps.LatLng(-40.647298, 176.364694));

			// Init the autocomplete holder
			var autocomplete = new google.maps.places.Autocomplete(
				(input[0]),
				{
					bounds: wellingtonRegionBounds,
					strictBounds: true,
					types: [
						'geocode'
					]
				}
			);

	        // Set initial restrict to the greater list of countries.
	        autocomplete.setComponentRestrictions({'country': ['nz']});

	        // Specify only the data fields that are needed.
	        autocomplete.setFields(['address_components', 'name']);

			// When the user selects an address from the dropdown
			autocomplete.addListener('place_changed', place_changed);

			function place_changed() {
				var place = autocomplete.getPlace();
				var place_as_string = "";
				var addressFieldType = 'Form_Form_';

				// If we are on the Section224C form, then use a different field type to prepopulate the fields.
				if($(document).find('#Form_Section224CSubmissionForm').length > 0) {
					addressFieldType = 'Form_Section224CSubmissionForm_';
				}

				// Get each component of the address from the place details
				// and fill the corresponding field on the form.
				for (var i = 0; i < place.address_components.length; i++) {

					var address_type = place.address_components[i].types[0];

					if (components_to_capture[address_type]){
						place_as_string += place.address_components[i][components_to_capture[address_type]];
						var addressType = place.address_components[i].types[0];
						var val = place.address_components[i][components_to_capture[addressType]];

						switch (address_type){
							case 'street_number':
								place_as_string += ' ';
								break;

							case 'route':
							case 'locality':
							case 'administrative_area_level_1':
							case 'sublocality_level_1':
								place_as_string += ', ';
								break;
						}
      					document.getElementById(addressFieldType + addressType).value = val;
					}
				}

				input.val(place_as_string);
			}
		});
	}
});
